import React, { useState } from 'react';
import { Box, CircularProgress, IconButton, TextField } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';

interface ZpravaVstupProps {
    /**
     * Odesle zpravu. Vraci promise, ktera se splni AZ podle vysledku - vstupni pole
     * se podle ni vyprazdni jen pri uspechu.
     */
    onOdeslat: (text: string) => Promise<unknown>;
    /** HO-152: uzivatel prave pise. Skrceni na 5,5 s resi spojeni, takze se to
     *  smi volat pri kazde klavese; bez ziveho socketu je to prazdna operace. */
    onPisu?: () => void;
    odesilaSe: boolean;
}

/**
 * HO-147 Task 4: kompozicni pole chatu. Renderuje se v `ChatPage` jen kdyz
 * je psani povolene (MODUL_CHAT zapnuty a mimo demo rezim) - viditelnost
 * resi rodic, tahle komponenta o gatingu nic nevi.
 */
const ZpravaVstup: React.FC<ZpravaVstupProps> = ({ onOdeslat, onPisu, odesilaSe }) => {
    const [text, setText] = useState('');

    const odeslat = () => {
        const trimmed = text.trim();
        if (!trimmed || odesilaSe) return;
        // Pole se maze AZ PO uspesnem odeslani. Drive se mazalo hned a napsany text
        // byl pri jakemkoli selhani NENAVRATNE pryc - zbyl jen toast. A selhani jsou
        // pritom legitimni a bezna: 429 (rychlostni limit), 403 (modul vypnuty, flag
        // se cachuje 5 minut), 409 (uloziste neaktivovane), 503 (vypadek registru
        // flagu) nebo obycejny vypadek site na Raspberry ve zbrojnici. Web nema
        // odesilaci frontu jako mobil, takze ztrata byla definitivni - a velitel behem
        // zasahu prisel o celou napsanou zpravu.
        onOdeslat(trimmed)
            .then(() => setText(''))
            .catch(() => { /* text zustava v poli, hlasku uz ukazala mutace */ });
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', pt: 1.5 }}>
            <TextField
                fullWidth
                multiline
                maxRows={4}
                label="Napište zprávu"
                value={text}
                onChange={(event) => {
                    setText(event.target.value);
                    // Az PO zapsani znaku - mazani textu je taky psani, ale prazdne
                    // pole uz ne: jinak by indikator svitil i po odeslani.
                    if (event.target.value.trim()) {
                        onPisu?.();
                    }
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' && !event.shiftKey) {
                        event.preventDefault();
                        odeslat();
                    }
                }}
                disabled={odesilaSe}
                size="small"
            />
            <IconButton
                color="primary"
                aria-label="Odeslat zprávu"
                onClick={odeslat}
                disabled={!text.trim() || odesilaSe}
            >
                {odesilaSe ? <CircularProgress size={20} /> : <SendIcon />}
            </IconButton>
        </Box>
    );
};

export default ZpravaVstup;
